import React from 'react';

// Barra de impersonação: aparece quando o master está navegando dentro de um tenant.
// Marcador: 'impersonacao' no localStorage (gravado pelo painel master ao clicar "Entrar como").
// O token original do master continua em 'master_token' — não é sobrescrito nem apagado,
// então voltar ao painel master não exige novo login.
export const ALTURA_BARRA = 40;

export function getImpersonacao() {
  try {
    if (!localStorage.getItem('master_token')) return null; // sem sessão master, não é impersonação
    const raw = localStorage.getItem('impersonacao');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export const impersonando = () => !!getImpersonacao();

export function voltarAoMaster() {
  // O token do master nunca foi perdido: só descartamos a sessão do tenant.
  localStorage.removeItem('impersonacao');
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  window.location.href = '/master';
}

export default function ImpersonationBar() {
  const imp = getImpersonacao();
  if (!imp) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, height: ALTURA_BARRA + 'px', zIndex: 9999,
      background: '#F59E0B', color: '#3B2600',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px',
      padding: '0 16px', fontFamily: "'DM Sans',system-ui,sans-serif", fontSize: '13px', fontWeight: '600',
      boxShadow: '0 1px 6px rgba(0,0,0,0.2)', boxSizing: 'border-box',
    }}>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        👁️ Você está visualizando como <strong>{imp.empresa_nome}</strong>
      </span>
      <button onClick={voltarAoMaster} style={{
        background: '#3B2600', border: 'none', color: '#FFD98A', padding: '5px 12px',
        borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '700',
        fontFamily: "'DM Sans',system-ui,sans-serif", flexShrink: 0,
      }}>Voltar ao Master</button>
    </div>
  );
}
